export default "https://cdn-shared.mathletics.com/teacher-modules/mx-portal/278/assets/images/new_badge_mx-438f5c6121f13af6e27c62b5f14a05da.png";